import isHexColor from 'validator/lib/isHexColor';
import colors from '~/theme/colors.module.scss';

export const spacing = (val: number) => val * 8;

export const getContrastTextColor = (color: string) => {
  if (!isHexColor(color)) return 'white';

  const hexcolor = color.length === 4 ? `${color}${color.substring(1, 4)}` : color;
  const r = parseInt(hexcolor.substring(1, 3), 16);
  const g = parseInt(hexcolor.substring(3, 5), 16);
  const b = parseInt(hexcolor.substring(5, 7), 16);
  const yiq = (r * 215 + g * 440 + b * 105) / 1000;
  return yiq >= 128 ? colors.colorGrey800 : 'white';
};

export const varColorToHexColor = (varColor: string) => {
  if (isHexColor(varColor)) return varColor;

  const plainVar = varColor.replace('var(', '').replace(')', '');
  return window.getComputedStyle(document.documentElement).getPropertyValue(plainVar);
};
